import { render } from "./ResearcherProfile.vue?vue&type=template&id=32f2fc99&scoped=true"
import script from "./ResearcherProfile.vue?vue&type=script&lang=js"
export * from "./ResearcherProfile.vue?vue&type=script&lang=js"

import "./ResearcherProfile.vue?vue&type=style&index=0&id=32f2fc99&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2fc99"]])

export default __exports__